<template>
  <div>
    <div v-if="loading">加载中...</div>
    <div v-else class="error">
      <div>哎呀，系统出错了</div>
      <div class="button" @click="reLogin()">重试</div>
    </div>
  </div>
</template>

<script>
import { getType, setUser } from "../../utils/auth";
import { mapActions } from "vuex";
import { setZlb } from "../../utils/auth";

export default {
  data() {
    return {
      loading: true,
      goto: ""
    };
  },
  mounted() {
    // console.log(this.$route);
    if (this.$route.query.from === "zlb") {
      setZlb("zlb");
      this.reLogin();
    }
  },
  methods: {
    // 重试
    reLogin() {
      this.$vux.loading.show();
      this.login({
        grant_type: "zlb",
        ticket: this.$route.query.ticket
      })
        .then(res => {
          this.$vux.loading.hide();
          if (res.user_id) {
            if (getType() === "user") {
              this.$router.replace({ path: "/home" });
            } else {
              this.$router.replace({ path: "/salesman/index" });
            }
          } else {
            setUser(res);
            // if (confirm("您尚未绑定客户账号，获取手机号绑定")) {
            // eslint-disable-next-line
                        wx.miniProgram.navigateTo({ url: "/pages/login/login" });
            // }
          }
        })
        .catch(() => {
          this.loading = false;
          this.$vux.loading.hide();
        });
    },
    ...mapActions(["login"])
  }
};
</script>

<style>
.error {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-top: 100px;
}
.button {
  background-color: #2582ff;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-size: 14px;
  position: relative;
  color: #fff;
  padding: 5px 25px;
  box-sizing: border-box;
  margin-top: 20px;
}
</style>
